import { gql, useQuery } from "@apollo/client"

const USER_ACCREDITATION_FIELDS = `
  id
  accreditation { id name description icon expires }
  notes
  uploads { id key fileName fileGroup fileSize }
  warningAt
  expiresAt
  status
  statusAt
  createdAt
`

const USER_ACCREDITATIONS_QUERY = gql`
  query UserAccreditations($user: ID!) {
    userAccreditations(user: $user) {
      ${USER_ACCREDITATION_FIELDS}
    }
  }
`

const userAccreditationTypePolicies = {
  UserAccreditation: {
    fields: {
      uploads: {
        merge(prev, next) {
          return [...next]
        },
      },
    },
  },
}

const useQueryUserAccreditations = (options) => useQuery(USER_ACCREDITATIONS_QUERY, options)

export { useQueryUserAccreditations, USER_ACCREDITATION_FIELDS, userAccreditationTypePolicies }
